import { Permission } from "./Permission";

export class PermissionInfo {
    customerPermissions: Permission[];
}